/**
 * B2COrderEditHistory — renders a B2C order's edit_history (who / when / what)
 * on the detail page. Each entry: actor + IST timestamp + the field-level diff
 * (field: old → new) recorded by order_service.update_order.
 */
const FIELD_LABELS = {
  payment_mode: "Payment mode",
  order_value: "Order value",
  cod_amount: "COD amount",
  pickup_location_id: "Pickup location",
  reference_number: "Reference",
  zone: "Zone",
  products: "Products",
  "buyer.name": "Buyer name",
  "buyer.phone": "Buyer phone",
  "buyer.email": "Buyer email",
  "buyer.address": "Buyer address",
  "buyer.landmark": "Buyer landmark",
  "buyer.pincode": "Buyer pincode",
  "buyer.city": "Buyer city",
  "buyer.state": "Buyer state",
  "buyer.alt_phone": "Buyer alt phone",
  "package.dead_weight_kg": "Dead weight",
  "package.length_cm": "Length",
  "package.breadth_cm": "Breadth",
  "package.height_cm": "Height",
};

const fmtVal = (v) => {
  if (v === null || v === undefined || v === "") return "—";
  if (typeof v === "boolean") return v ? "Yes" : "No";
  return String(v);
};

const fmtWhen = (at) => {
  if (!at) return "";
  const d = new Date(at);
  if (Number.isNaN(d.getTime())) return String(at);
  return d.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata", day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
};

export function B2COrderEditHistory({ editHistory }) {
  const entries = Array.isArray(editHistory) ? editHistory : [];
  if (entries.length === 0) {
    return <p className="text-sm text-slate-500">No edits yet.</p>;
  }
  // Newest first.
  const ordered = [...entries].reverse();
  return (
    <ol className="space-y-3" data-testid="order-edit-history">
      {ordered.map((ev, i) => {
        const actor = ev.actor || {};
        const who = actor.user_name || actor.user_email || "Unknown";
        const changes = Array.isArray(ev.changes) ? ev.changes : [];
        return (
          <li key={ev.at ? `${ev.at}-${i}` : i} className="rounded-lg border bg-white p-3">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <span className="text-xs font-medium text-slate-700">
                {who}{actor.role ? ` · ${actor.role}` : ""}
              </span>
              <span className="text-xs tabular-nums text-slate-400">{fmtWhen(ev.at)}</span>
            </div>
            <div className="mt-2 flex flex-wrap gap-1">
              {changes.map((c, j) => (
                <span key={j} className="rounded bg-slate-50 px-1.5 py-0.5 text-xs tabular-nums text-slate-600 ring-1 ring-slate-200">
                  {FIELD_LABELS[c.field] || c.field}: {fmtVal(c.from)} → {fmtVal(c.to)}
                </span>
              ))}
            </div>
          </li>
        );
      })}
    </ol>
  );
}

export default B2COrderEditHistory;
